import React from 'react';
import * as S from './styles';
import { renderColorProcurementStatus } from '../status/procurementStatusComponent';
import { renderColor } from '../status/statusCartComponent';
import { renderColorManagerPackagesStatus } from '../status/statusColorManagerPackages';
import { ProcurementStatusEnum } from '@/main/services/enum/StatusProcurement';
import TooltipComponent from '../tooltip/tooltipComponent';
import { IKogIcon } from '@/main/@types/interfaceIcons';
import {
  ReturnIcon,
  CarIcon,
  TransferredIcon,
  DeliveredIcon,
  TransitIcon,
  CancelledIcon,
  AnsweredAssignedIcon,
  AwaitingReleaseIcon,
  ReceivedIcon,
  InvoicedIcon,
  PaidIcon,
  PreQuoteIcon,
  MesaDeComprasIcon,
  PendingAnswerIcon,
  AwaitingPaymentIcon
} from '@/main/components/shared/icons';
import { isNullUndefined } from '@/main/services/utils';
import { StatusCartEnum } from '@/main/services/enum/StatusCartEnum';
import { AwaitingApprovalIcon } from '@/main/components/shared/icons/awaitingApprovalIcon';

interface ICardStatus {
  idStatus: number;
  value: string;
  numberOfValues: number;
  isCartCardStatus?: boolean;
  onClick?: () => void;
  isManagePackages?: boolean;
}
function KOGCardStatus({
  idStatus,
  value,
  numberOfValues,
  isCartCardStatus,
  onClick,
  isManagePackages
}: ICardStatus) {
  const colorFormatted = isManagePackages ? renderColorManagerPackagesStatus(idStatus) : (
    isCartCardStatus ? renderColor(idStatus) :
      renderColorProcurementStatus(idStatus)
  );

  const basePropsIcon: IKogIcon = {
    height: '30px',
    width: '40px',
    color: colorFormatted
  }

  const mapIconStatusOrderScreen: Record<number, React.ReactNode> = {
    [ProcurementStatusEnum.Assigned]: <AnsweredAssignedIcon {...basePropsIcon} />,
    [ProcurementStatusEnum.Transit]: <TransitIcon {...basePropsIcon} width='32px' />,
    [ProcurementStatusEnum.Delivered]: <DeliveredIcon {...basePropsIcon} height='30px' />,
    [ProcurementStatusEnum.Invoiced]: <InvoicedIcon {...basePropsIcon} />,
    [ProcurementStatusEnum.Paid]: <PaidIcon {...basePropsIcon} />,
    [ProcurementStatusEnum.Open]: <CarIcon {...basePropsIcon} />,
    [ProcurementStatusEnum.Cancelled]: <CancelledIcon {...basePropsIcon} width='30px' height='22px' />,
    [ProcurementStatusEnum.Received]: <ReceivedIcon {...basePropsIcon} width='30px' />,
    [ProcurementStatusEnum.PreQuote]: <PreQuoteIcon {...basePropsIcon} width='30px' />,
    [ProcurementStatusEnum.Returned]: <ReturnIcon {...basePropsIcon} width='30px' height='22px' />,
    [ProcurementStatusEnum.Transferred]: <TransferredIcon {...basePropsIcon} width='30px' height='22px' />,
    [ProcurementStatusEnum.WaitingRelease]: <AwaitingReleaseIcon {...basePropsIcon} />,
    [ProcurementStatusEnum.Manual]: <MesaDeComprasIcon  {...basePropsIcon} />,
    [ProcurementStatusEnum.Closed]: null,
    [ProcurementStatusEnum.ReturnApprovalProcess]: null,
    [ProcurementStatusEnum.CancelProcess]: null,
    [ProcurementStatusEnum.ReturnProcess]: null,
    [ProcurementStatusEnum.AwaitingPayment]: <AwaitingPaymentIcon {...basePropsIcon} width='50px' height='30px' />,
    [ProcurementStatusEnum.AwaitingApproval]: <AwaitingApprovalIcon {...basePropsIcon} width='32px' height='32px'/>,
  };
  const mapiconStatusPendingAnswerScreen: Record<number, React.ReactNode> = {
    [StatusCartEnum.Pending]: <PendingAnswerIcon {...basePropsIcon} />,
    [StatusCartEnum.Answered]: <AnsweredAssignedIcon {...basePropsIcon} />,
    [StatusCartEnum.Cart]: null
  }

  const mapIconStatus = isManagePackages ? {} : isCartCardStatus ? mapiconStatusPendingAnswerScreen : mapIconStatusOrderScreen;

  return (
    <TooltipComponent
      placement='top'
      title={value}
    >
      <S.Container onClick={onClick} id={`id-general-card-status-${value}`}>
        <S.TitleCount $color={colorFormatted}>{numberOfValues}</S.TitleCount>
        {isNullUndefined(mapIconStatus[idStatus]) ? (
          <>
            <S.TitleNameStatus title={value}>{value}</S.TitleNameStatus>
            <S.Ball color={colorFormatted} />
          </>
        ) :
          <S.AreaIcon>
            {mapIconStatus[idStatus]}
          </S.AreaIcon>
        }

      </S.Container>
    </TooltipComponent>

  );
}

export default KOGCardStatus;